module.exports = __webpack_public_path__ + "static/media/kris-atomic-ZgMMjAR9b20-unsplash.d8a885b2.jpg";